const styles = {
  p: {
    display: "block",
    fontFamily: "Lato, sans-serif",
    margin: "0 0 10px",
    fontSize: 13
  }
}
const VehicleDA_Directions = () => {
  return (
    <>
      <h5 className='text-primary text-center fw-bold mb-5'>DRIVER ASSIGNMENT</h5>
      <div className="col-12 col-sm-12 mb-4">
        <strong className="text-primary col-sm-12" style={{ fontSize: '16px' }}>
          For each vehicle, select the driver that operates the vehicle on a regular basis. 
          If a vehicle is operated by more than one driver on a regular basis, select the driver who drives the vehicle most frequently.
        </strong>
      </div>
    </>
  )
}

export default VehicleDA_Directions